import { render } from "./SpoofUserMenu.vue?vue&type=template&id=3beb2c54&ts=true"
import script from "./SpoofUserMenu.vue?vue&type=script&lang=ts"
export * from "./SpoofUserMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__